import Us from "../sections/Us"
import Guima from "../sections/Guima"
import Thinking from "../sections/Thinking"
import Licence from "../sections/Licence"
import Faq from "../sections/Faq"
import People from "../sections/People"
import Luck from "../sections/Luck"
import Music from "../sections/Music"
import Thanks from "../sections/Thanks"

function Site2025() {
  return (
    <>
      <Us />
      <Guima />
      <Thinking />
      <Licence />
      <Faq />
      <People />
      <Luck />
      <Music />
      <Thanks />
      <div
        id="final-links-2025"
        className="d-flex align-items-center justify-content-center"
      >
        <a href="/">Voltar</a>
      </div>
    </>
  );
}

export default Site2025;
